export default __webpack_public_path__ + "static/media/brand-logo.12c97bee.png";